import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Board } from 'src/app/core/models/board.model';
import { BoardRead } from 'src/app/core/models/boardRead.model';
import { BoardStats } from 'src/app/core/models/boardStats.model';
import { BoardService } from 'src/app/core/services/board.service';
import { boardReadService } from 'src/app/core/services/boardRead.service';
import { BoardStatService } from 'src/app/core/services/boardstats.service';

interface BoardStatSums {
  coinInDiff: number
  coinOutDiff: number
  cashInDiff: number
  cashOutDiff: number
  gamesPlayed: number
  profit: number
  gamePlayedDiff: number
  gameWonDiff: number
  daysSincePrevRead: number
}

@Component({
  selector: 'app-board-stats-by-id',
  templateUrl: './boardStatsById.component.html',
  styleUrls: ['./boardStatsById.component.scss']
})

/**
 * Dashboard Component
 */
export class BoardStatsByIdComponent implements OnInit {
  term: any;
  @Input() assetTag: string;  // Input to receive the assetTag for filtering the board stats
  boardStats: BoardStats[] = [];
  summary: BoardStatSums = {
    coinInDiff: 0,
    coinOutDiff: 0,
    cashInDiff: 0,
    cashOutDiff: 0,
    gamesPlayed: 0,
    profit: 0,
    gamePlayedDiff: 0,
    gameWonDiff: 0,
    daysSincePrevRead: 0,
  };
  actualProfit: number;
  avgHoldPercent: number;

  constructor(
    private boardService: BoardService, private boardStatsService: BoardStatService, 
    private modalService: NgbModal,private _Activatedroute:ActivatedRoute,
    private _router:Router,  public activeModal: NgbActiveModal 
  ){
  }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Board Stats', active: true }];
    await this.refresh();
  }
  async refresh() {
    this.boardStats = await this.boardStatsService.getByBoardAssetTag(this.assetTag);
    this.boardStats.forEach((elem) => {
      this.summary.coinInDiff += elem.coinInDiff;
      this.summary.coinOutDiff += elem.coinOutDiff;
      this.summary.cashInDiff += elem.cashInDiff;
      this.summary.cashOutDiff += elem.cashOutDiff;
      this.summary.gamePlayedDiff += elem.gamePlayedDiff;
      this.summary.gameWonDiff += elem.gameWonDiff;
      this.summary.daysSincePrevRead += elem.daysSincePrevRead;
      this.summary.profit += elem.profit;
    });
    this.actualProfit = this.summary.cashInDiff - this.summary.cashOutDiff;
    this.avgHoldPercent = this.summary.cashInDiff > 0 ? (this.summary.cashOutDiff /  this.summary.cashInDiff) *100
    : 0;
  }

  getAverageDays(): number {
    return this.boardStats.length > 0 ? 
      this.summary.daysSincePrevRead / this.boardStats.length : 0;
  }
}
